import { ItemView } from '@glu/core';
import template from './imageCell.hbs';

/**
 * This ItemView represents a simple image content.
 */
export default ItemView.extend({
  template,

  templateHelpers() {
    return {
      id: this.model.cid
    };
  }
});
